import React from 'react';
import {
  Add as AddIcon,
  DeleteOutlined as DeleteOutlinedIcon,
  KeyboardArrowDown as KeyboardArrowDownIcon,
} from '@mui/icons-material';
import { Button } from '@mui/material';

// Note: returning the buttons as a list instead of a React component improves the performance somehow
export const getFormulaConditionItemActions = ({
  conditionType,
  onAddNewConditionGroup,
  onAddNewCriterion,
  onDelete,
  elementId = 'root',
  isRoot = false,
}) => {
  const buttons = [];

  if (conditionType !== 'criterion') {
    buttons.push(
      <Button
        key={`${elementId}-new-criterion-button`}
        data-cy={`${elementId}-new-criterion-button`}
        color="inherit"
        sx={{ minWidth: '24px', m: 0, ml: 4, p: 0 }}
        variant="outlined"
        onClick={onAddNewCriterion}
      >
        <AddIcon />
      </Button>
    );
    buttons.push(
      <Button
        key={`${elementId}-new-group-button`}
        data-cy={`${elementId}-new-group-button`}
        color="inherit"
        sx={{ minWidth: '24px', m: 0, p: 0 }}
        variant="outlined"
        onClick={onAddNewConditionGroup}
      >
        <KeyboardArrowDownIcon />
      </Button>
    );
  }

  if (!isRoot)
    buttons.push(
      <Button
        key={`${elementId}-delete-button`}
        data-cy={`${elementId}-delete-button`}
        color="error"
        sx={{ minWidth: '24px', m: 0, ml: 1, p: 0 }}
        onClick={onDelete}
      >
        <DeleteOutlinedIcon />
      </Button>
    );
  return buttons;
};
